import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryMethodsListSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="rounded" width="100%" height={24} />
    {Array.from({ length: 4 }).map((_, index) => (
      <Skeleton key={index} variant="rounded" width="100%" height={80} />
    ))}
  </Styles.Container>
)

export default DeliveryMethodsListSkeleton
